import { render, staticRenderFns } from "./SanmakView.vue?vue&type=template&id=9803e828&scoped=true"
import script from "./SanmakView.vue?vue&type=script&lang=js"
export * from "./SanmakView.vue?vue&type=script&lang=js"
import style0 from "./SanmakView.vue?vue&type=style&index=0&id=9803e828&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9803e828",
  null
  
)

export default component.exports